import Vue from 'vue'
import Vuex from 'vuex'
import Cookie from 'vue-cookies';

import common from '@/common/common.js'

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        langcur: common.basic.chstr2int(Cookie.get('lang'), 1),
        langdic: common.json.sync('/include/dic2.json'),
        config: common.json.sync('/include/config.json'),
        logourl: '',
        face: '',
        username: '',
        showname: '',
        islogin: common.basic.chstr2int(Cookie.get('islogintok')),
        memlev: common.basic.chstr2int(Cookie.get('memlevtok')),
        wh: window.innerHeight,// document.body.clientHeight;
        ww: window.innerWidth,// document.body.clientWidth;
        hftype: 1,
        toptitle: '',
        cameraid: ''//摄像头
    },
    getters: {
        isstu: state => state.memlev == 1,
        istea: state => state.memlev == 2,
        issmall: state => state.ww <= 600
    },
    mutations: {
        SET_ISLOGIN(state, v) {
            if (state.islogin != v) {
                state.islogin = v;
                Cookie.set('islogintok', v, -1);
            }
        },
        SET_MEMLEV(state, v) {
            if (state.memlev != v) {
                state.memlev = v;
                Cookie.set('memlevtok', v, -1);
            }
        },
        SET_LANGCUR(state, v) {
            if (state.langcur != v) {
                state.langcur = v;
                Cookie.set('lang', v, -1);
            }
        },
        SET_LOGOURL(state, v) {
            if (state.logourl != v) {
                state.logourl = v;
            }
        },
        SET_USERNAME(state, v) {
            if (state.username != v) {
                state.username = v;
            }
        },
        SET_SHOWNAME(state, v) {
            if (state.showname != v) {
                state.showname = v;
            }
        },
        SET_FACE(state, v) {
            if (state.face != v) {
                state.face = v;
            }
        },
        SET_CAMERAID(state, v) {
            if (state.cameraid != v) {
                state.cameraid = v;
            }
        },
        SET_HF(state, v) {
            if (state.toptitle != v) {
                state.toptitle = v;
                state.hftype = v ? 2 : 1;
            }
        },
        SET_WINDOWSIZE(state) {
            state.wh = window.innerHeight;// document.body.clientHeight;
            state.ww = window.innerWidth;// document.body.clientWidth;
        }
    },
    actions: {
        setislogin({ commit }, v) {
            commit('SET_ISLOGIN', v);
        },
        setmemlev({ commit }, v) {
            commit('SET_MEMLEV', v);
        },
        setlangcur({ commit }, v) {
            commit('SET_LANGCUR', v);
        },
        setlogourl({ commit }, v) {
            commit('SET_LOGOURL', v);
        },
        setusername({ commit }, v) {
            commit('SET_USERNAME', v);
        },
        setshowname({ commit }, v) {
            commit('SET_SHOWNAME', v);
        },
        setface({ commit }, v) {
            commit('SET_FACE', v);
        }
    }
});

export default store;
